module.exports = {"body":"<p>Need more space? Maybe you like to work on cars, or have a hobby shop you’d like to\nexpand. Sometimes the old garage just needs to be rebuilt.</p>\n<p>Whatever the reason, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Garage.md
// module id = 513
// module chunks = 0